import { MarkerDataModel } from '@/models/marker/marker';
import { markerSerilaizer } from '@/providers/serializers/markers/markers';
import { http } from '../http';

export class MarkersAPI  {

    private static INSTANCE = new MarkersAPI();

    private namespace: string = 'api/ecpa/v1';

    private searchNamespace: string = 'gooru-search/rest/v1';

    private rerouteNamespace: string = 'api/routegenerator/v1';

    private showcaseNamespace: string = 'api/navigate-map/v4/showcase';

    private nucleusNamespace: string = 'api/nucleus/v2';

    static get instance() {
        return this.INSTANCE;
    }

    public updateCompetencyMarker(markerData: MarkerDataModel) {
        const endpoint = `${this.namespace}/activity/assessmentcomplete`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, markerData);
    }

    public searchMarkers(params: any) {
        const endpoint =  `${this.searchNamespace}/markers`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return markerSerilaizer.normalizeMarkerSearchData(response.data);
        });
    }

    public fetchRerouteContent(params: any) {
        const endpoint = `${this.showcaseNamespace}/learningjourney`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return markerSerilaizer.normalizeGeneratedRoute(response.data);
        });
    }

    public generateMarker(params: any) {
        const endpoint = `${this.showcaseNamespace}/learningjourney`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return response.data;
        });
    }

    public updateRouteData(payload: any) {
        const endpoint = `${this.showcaseNamespace}/reroute`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, payload).then((response) => {
            return markerSerilaizer.normalizeSuggestions(response.data);
        });
    }

    public fetchRouteLessons(param: any) {
        const endpoint = `${this.nucleusNamespace}/lessons/${param.lessonId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return markerSerilaizer.normalizeCollectionsData(response.data);
        });
    }

}
export const markersAPI = MarkersAPI.instance;
